import type { ComponentProps, ComponentState, Slot } from '@fluentui/react-components';

export type ChatInputEntitySlots = {
  root: NonNullable<Slot<'span'>>;
  text: Slot<'span', 'a'>;
  sensitivity?: Slot<'span'>;
};

/**
 * ChatInputEntity Props
 */
export type ChatInputEntityProps = ComponentProps<Partial<ChatInputEntitySlots>, 'text'> & {};

/**
 * State used in rendering ChatInputEntity
 */
export type ChatInputEntityState = ComponentState<ChatInputEntitySlots>;
// TODO: Remove semicolon from previous line, uncomment next line, and provide union of props to pick from ChatInputEntityProps.
// & Required<Pick<ChatInputEntityProps, 'propName'>>
